import LocationGroupType from "./LocationGroupType";
import LocationType from "./LocationType";
const groups = Object.keys(LocationGroupType);
const LocationSubType = Object.freeze(Object.keys(LocationType).filter(type => type.includes("__") && !groups.includes(type)).reduce((obj, type) => {
  obj[type] = type;
  return obj;
}, {}));
export default LocationSubType;